// extracted by mini-css-extract-plugin
export default {"openBoxes":"HomePage_openBoxes__psK8Y","contactInputs":"HomePage_contactInputs__Mowdj","iframe":"HomePage_iframe__USKeW"};